import React, { useEffect, useState } from "react";
import { Pagination } from "antd";
import UnassignStudentModal from "./unassignGuideModal/UnassignMockStudentModal";
import InterviewSearchSec from "./InterviewSearchSec";
import InterviewStudentsTable from "./InterviewStudentsTable";
import { getCandidateDetailsApi } from "../../../../../api/org-admin";
import WebUtils from "../../../../../utils/WebUtils";

const InterviewTableMain = ({
  userDetail,
  setLoading,
  iDronaId,
  getGuideDetails,
}) => {
  const [studentsData, setStudentsData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [sortBy, setSortBy] = useState("SORT_BY_ASSIGNED_DATE_DESC");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageCount, setPageCount] = useState(5);
  const [pageSize, setPageSize] = useState(5);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [unAssignStudentFlag, setUnAssignStudentFlag] = useState(false);
  const [interviewState, setInterviewState] = useState("ALL");
  const [batchIdsFilter, setBatchIdsFilter] = useState(null);

  const getStudents = (pageNo, pageSize, searchInput, state, batchId) => {
    const url = `${getCandidateDetailsApi}?organizationId=${
      userDetail?.organizationId || null
    }&iDronaInterviewConfigurationId=${iDronaId}&pageNumber=${pageNo}&pageSize=${pageSize}&searchInput=${searchInput}&interviewState=${state}`;
    setLoading(true);

    let req = {
      sortBy: sortBy,
      batchIds: batchIdsFilter,
    };

    WebUtils.httpOperations(url, req, "POST")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setStudentsData(result?.data?.data?.candidateList);
          setPageCount(result?.data?.data?.totalCount);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const refreshApis = () => {
    getGuideDetails();
    getStudents(0, 5, "", interviewState);
    // setInterviewState("ALL")
  };

  const onPageChange = (num, pageSize) => {
    setCurrentPage(num - 1);
    setPageSize(pageSize);
  };

  useEffect(() => {
    getStudents(currentPage, pageSize, searchValue, interviewState);
  }, [
    pageSize,
    currentPage,
    sortBy,
    searchValue,
    interviewState,
    batchIdsFilter,
  ]);

  return (
    <div className="mt-3">
      <>
        {unAssignStudentFlag && (
          <UnassignStudentModal
            unAssignStudentFlag={unAssignStudentFlag}
            setUnAssignStudentFlag={setUnAssignStudentFlag}
            setLoading={setLoading}
            selectedUserIds={selectedUserIds}
            refreshApis={refreshApis}
          />
        )}
        <InterviewSearchSec
          searchText={searchText}
          setSearchText={setSearchText}
          studentsData={studentsData}
          setSearchValue={setSearchValue}
          searchValue={searchValue}
          selectedUserIds={selectedUserIds}
          refreshApis={refreshApis}
          unAssignStudentFlag={unAssignStudentFlag}
          setUnAssignStudentFlag={setUnAssignStudentFlag}
          setSortBy={setSortBy}
          sortBy={sortBy}
          setInterviewState={setInterviewState}
          interviewState={interviewState}
          batchIdsFilter={batchIdsFilter}
          setBatchIdsFilter={setBatchIdsFilter}
          iDronaId={iDronaId}
        />
        <InterviewStudentsTable
          studentsData={studentsData}
          setSelectedUserIds={setSelectedUserIds}
          selectedUserIds={selectedUserIds}
          unAssignStudentFlag={unAssignStudentFlag}
          setUnAssignStudentFlag={setUnAssignStudentFlag}
        />
        <div className="flex justify-center mt-3 mb-1">
          <Pagination
            current={currentPage + 1}
            total={pageCount}
            pageSize={pageSize}
            onChange={onPageChange}
            showSizeChanger={true} // ✅ enable page size selector
            pageSizeOptions={["5", "10", "15", "20"]} // options for items per page
          />
        </div>
      </>
    </div>
  );
};

export default InterviewTableMain;
